import { Injectable } from '@angular/core'

export interface ModalController {
  close(): void
  isModalOpen?(): boolean // Optional method to check if modal is open
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private registeredModals: Map<any, ModalController> = new Map()

  constructor() {
    // Set up global escape key listener
    document.addEventListener('keydown', this.onEscapeKey.bind(this))
  }

  /**
   * Register a modal component
   */
  register(component: any, controller: ModalController): void {
    this.registeredModals.set(component, controller)
  }

  /**
   * Unregister a modal component (call in ngOnDestroy)
   */
  unregister(component: any): void {
    this.registeredModals.delete(component)
  }

  private onEscapeKey(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      // Close all open modals when escape is pressed
      this.registeredModals.forEach((controller) => {
        // Only try to close if the modal is open (if the method exists) or just close by default
        if (!controller.isModalOpen || controller.isModalOpen()) {
          controller.close()
        }
      })
    }
  }
}
